/** The legacy SDK value and the visible lifecycle value share one filter. */
export function normaliseWorkflowStatus(status: string): string {
  return status === "pending" ? "queued" : status;
}

/** Pass the displayed status after any interrupted/cancelled parent projection. */
export function matchesWorkflowStatus(displayedStatus: string, selectedStatuses: readonly string[]): boolean {
  const status = normaliseWorkflowStatus(displayedStatus);
  return selectedStatuses.length === 0
    || selectedStatuses.some((selected) => normaliseWorkflowStatus(selected) === status);
}
